import { useEffect } from "react";
import ContactInfo from "../Contact/ContactInfo";
import NewContact from "../Contact/NewContact";
import { Helmet } from "react-helmet-async";

function Contact (){
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return(
    <div>
      <>
       <Helmet>
         <title>Contact Quad Theory Ltd | Start The Right Conversation</title>
         <meta
           name="description"
           content="Get in touch with Quad Theory Ltd to discuss software development projects or hire skilled developers and dedicated teams. Start a clear, no-pressure conversation about building or scaling your technology."
         />
       </Helmet>
      </>
    
        <NewContact></NewContact>
        <ContactInfo></ContactInfo>
    </div>
  )

}
export default Contact ;